<app-linkable
    typename="controls"
    [displayValueProp]="displayValueProp"
    [linked]="linked"
    [unlinked]="unlinked"
    [orderByValueProperty]="true"
    [disabled]="disabled"
    [hideActions]="hideActions"
    [hideFilter]="hideFilter"
    [allowAddNew]="allowAddNew"
    [rowIconConfig]="rowIconConfig"
    [rendererConfig]="rendererConfig"
    [showAdvancedFilters]="showAdvancedFilters"
    [activeFilters]="activeFilters"
    [filterConfig]="filterConfig"
    [moduleType]="moduleType"
    (onOpenClicked)="openItem($event)"
    (onAddClicked)="addClicked()"
    (onReloadClicked)="reloadClicked()"
    [allowEditItem]="allowEditItem"
    [allowBatchEdit]="allowBatchEdit"
    [allowOpenItem]="true"
    [allowReload]="true"
>
</app-linkable>
